<template>
  <v-flex >
    <v-toolbar flat class="transparent mb-4 text-xs-center">
      <v-btn icon to="/home" >
        <v-icon>arrow_back</v-icon>
      </v-btn>
      <v-toolbar-title class="headline text-xs-center">{{msg}}</v-toolbar-title>
    </v-toolbar>
   <v-card flat tile class="mb-4">
      <v-container  fluid grid-list-lg >
        <v-layout >
          <v-flex justify-center text-xs-left>
            <v-card-text>
                <div class="my-2" v-html="myHTML" ></div>
            </v-card-text>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
    <v-card flat tile class="mb-4">
      <v-container  fluid grid-list-lg >
        <v-layout >
          <v-flex justify-center text-xs-left>
            <v-card-text>
              <h1>Provide Feedback</h1>
              <p>As you use the app please feel free to tap “Provide Feedback” and let us know what’s up.
                If you’d like, you can choose to upload a screenshot of the issue. </p>
              <v-btn color="success mx-auto" large  onclick=" window.open('https://www.surveygizmo.com/s3/4338602/Voice-Tracker-Alpha-Feedback','_blank')">Provide Feedback</v-btn>
            </v-card-text>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </v-flex>
</template>
<script>



import AppConst from './AppConst.js'
import GetActivityHelpQuery from './queries/GetActivityHelpQuery';

var appTitleLocal = AppConst.appTitle;


function getHelpText( that, callback){
          that.$apollo.query({
                variables: {
                    id: 'HelpAdminText'
                },
                query: GetActivityHelpQuery})
                .then(function logData(data) {
                      if(data.data.getActivityHelp!== null){
                              //check for Sick
                              if(data.data.getActivityHelp.id=='HelpAdminText'){
                                  callback(data.data.getActivityHelp.notes);
                              }
                      }
                }).catch(console.error);
}

export default {
  data () {
    return {
      msg: 'Help',
      appTitle: appTitleLocal,
      myHTML: '',
    }
  },
  created: function(that=this)
  {
    // From testing, without a brief timeout, it won't work.
    getHelpText(that, function(data){
      that.myHTML=data;
    });
  },
  mounted: function(that=this)
  {
    setTimeout(() => that.scrollFix(), 500);
  },
  methods: {
    scrollFix: function()
    {
      if(window.location.hash!=''){
        var hashNameElement=window.location.hash.substr(1);
        var elmnt = document.getElementById(hashNameElement);
        var elmntTop= elmnt.offsetTop;
        elmnt.scrollIntoView({behavior: "smooth", block: "center", inline: "center"});
        console.log(hashNameElement);
        console.log(elmnt );
        console.log(elmntTop);
      }
    }
  }
}
 </script>
 <style scoped >

 h1{  text-transform:capitalize; margin-bottom: 12px;}

 </style>



// WEBPACK FOOTER //
// src/components/Help.vue